import React, { useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import "./App.scss";

import Home from "./pages/home";

import Design from "./pages/design";
import Movement from "./pages/movement";
import Music from "./pages/music";

import About from "./pages/about"

import Bank from "./pages/bank";
import Eyescann from "./pages/eyescann";
import CMS from "./pages/cms";
import NB from "./pages/nb";
import Renovations from "./pages/renovations";
import BP from "./pages/bp";

import Monstera from "./pages/monstera";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import InteractiveBackground from "./components/InteractiveBackground";

// import { Dynamic } from "./containers/backgrounds";

function App() {
  // const dark = useSelector((state) => state.dark);

  // const location = useLocation();

  // console.log(location.pathname);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1500)
    }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (null ) }
      <ThemeProvider>
        <div hidden={isLoading}>
          <InteractiveBackground />
          <Navbar />
          {/* <Dynamic dark={dark} /> */}
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/design">
              <Design />
            </Route>
            <Route path="/design/cms">
              <CMS />
            </Route>
            <Route path="/design/bank">
              <Bank />
            </Route>
            <Route path="/design/eyescan">
              <Eyescann />
            </Route>
            <Route exact path="/movement">
              <Movement />
            </Route>
            <Route path="/movement/nb">
              <NB />
            </Route>
            <Route path="/movement/renovations">
              <Renovations />
            </Route>
            <Route path="/movement/BP">
              <BP />
            </Route>
            <Route exact path="/music">
              <Music />
            </Route>
            <Route path="/monstera">
              <Monstera />
            </Route>
            <Route path="/about">
              <About />
            </Route>
          </Switch>
          <Footer />
        </div>
      </ThemeProvider>
    </>
  );
}

export default App;
